import { render, staticRenderFns } from "./caseList.vue?vue&type=template&id=f5073b58&"
import script from "./caseList.vue?vue&type=script&lang=js&"
export * from "./caseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports